import type { LoanFile } from '../types/files';

export const loanFiles: LoanFile[] = [
  {
    id: 'f-01',
    title: 'Uniform Residential Loan Application (1003)',
    extension: 'pdf',
    type: 'pdf',
    owner: 'Priya Raman',
    lastModifiedBy: 'Priya Raman',
    lastModified: '2026-08-28T14:44:00',
    sizeKb: 1340,
  },
  {
    id: 'f-02',
    title: 'Closing Disclosure — Preliminary',
    extension: 'pdf',
    type: 'pdf',
    owner: 'Priya Raman',
    lastModifiedBy: 'Marcus Hale',
    lastModified: '2026-08-27T12:01:00',
    sizeKb: 878,
  },
  {
    id: 'f-03',
    title: 'W-2 2025 — Whitfield',
    extension: 'pdf',
    type: 'pdf',
    owner: 'Jordan A. Whitfield',
    lastModifiedBy: 'Jordan A. Whitfield',
    lastModified: '2026-08-26T09:17:00',
    sizeKb: 412,
  },
  {
    id: 'f-04',
    title: 'Bank Statements — Q2 Consolidated',
    extension: 'xlsx',
    type: 'xls',
    owner: 'Marcus Hale',
    lastModifiedBy: 'Marcus Hale',
    lastModified: '2026-08-26T16:32:00',
    sizeKb: 246,
  },
  {
    id: 'f-05',
    title: 'Income Verification Worksheet',
    extension: 'xlsx',
    type: 'xls',
    owner: 'Priya Raman',
    lastModifiedBy: 'Priya Raman',
    lastModified: '2026-08-25T11:05:00',
    sizeKb: 128,
  },
  {
    id: 'f-06',
    title: 'Credit Report Export',
    extension: 'csv',
    type: 'csv',
    owner: 'System Integration',
    lastModifiedBy: 'System Integration',
    lastModified: '2026-08-25T07:00:00',
    sizeKb: 64,
  },
  {
    id: 'f-07',
    title: 'Appraisal Report — 412 Larkspur Ln',
    extension: 'pdf',
    type: 'pdf',
    owner: 'Dana Whitcombe',
    lastModifiedBy: 'Dana Whitcombe',
    lastModified: '2026-08-24T15:48:00',
    sizeKb: 3180,
  },
  {
    id: 'f-08',
    title: 'Property Photos — Exterior',
    extension: 'jpg',
    type: 'img',
    owner: 'Dana Whitcombe',
    lastModifiedBy: 'Dana Whitcombe',
    lastModified: '2026-08-24T15:44:00',
    sizeKb: 2260,
  },
  {
    id: 'f-09',
    title: 'Property Photos — Kitchen Remodel',
    extension: 'png',
    type: 'img',
    owner: 'Jordan A. Whitfield',
    lastModifiedBy: 'Jordan A. Whitfield',
    lastModified: '2026-08-23T18:21:00',
    sizeKb: 1720,
  },
  {
    id: 'f-10',
    title: 'Homeowners Insurance Binder',
    extension: 'pdf',
    type: 'pdf',
    owner: 'Jordan A. Whitfield',
    lastModifiedBy: 'Priya Raman',
    lastModified: '2026-08-22T10:12:00',
    sizeKb: 540,
  },
  {
    id: 'f-11',
    title: 'Title Commitment Letter',
    extension: 'docx',
    type: 'doc',
    owner: 'Ellis Trask',
    lastModifiedBy: 'Ellis Trask',
    lastModified: '2026-08-21T13:39:00',
    sizeKb: 96,
  },
  {
    id: 'f-12',
    title: 'Underwriting Conditions Memo',
    extension: 'docx',
    type: 'doc',
    owner: 'Marcus Hale',
    lastModifiedBy: 'Marcus Hale',
    lastModified: '2026-08-21T08:55:00',
    sizeKb: 72,
  },
  {
    id: 'f-13',
    title: 'Borrower Onboarding Deck',
    extension: 'pptx',
    type: 'ppt',
    owner: 'Priya Raman',
    lastModifiedBy: 'Priya Raman',
    lastModified: '2026-08-19T17:02:00',
    sizeKb: 4420,
  },
  {
    id: 'f-14',
    title: 'Rate Lock Confirmation Email',
    extension: 'html',
    type: 'html',
    owner: 'System Integration',
    lastModifiedBy: 'System Integration',
    lastModified: '2026-08-18T09:26:00',
    sizeKb: 22,
  },
  {
    id: 'f-15',
    title: 'Call Notes — Escrow Follow-up',
    extension: 'txt',
    type: 'txt',
    owner: 'Priya Raman',
    lastModifiedBy: 'Priya Raman',
    lastModified: '2026-08-17T14:10:00',
    sizeKb: 8,
  },
  {
    id: 'f-16',
    title: 'Prior Loan Archive (2019)',
    extension: 'zip',
    type: 'zip',
    owner: 'Records Management',
    lastModifiedBy: 'Records Management',
    lastModified: '2026-08-14T11:44:00',
    sizeKb: 6890,
  },
];
